// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import resolutionDocumentEntity from './entities/resolution-document.json';
import resolutionDocumentMenu from '../pages/resolution-document/menu.json';
import resolutionDocumentFullForm from '../pages/resolution-document/forms/full.json';
import resolutionDocumentContextForm from '../pages/resolution-document/forms/context.json';
import resolutionDocumentMiniForm from '../pages/resolution-document/forms/mini.json';
import resolutionDocumentLookupForm from '../pages/resolution-document/forms/lookup.json';
import resolutionDocumentTableView from '../pages/resolution-document/views/table.json';
import resolutionDocumentCardsView from '../pages/resolution-document/views/cards.json';
import resolutionDocumentCalendarView from '../pages/resolution-document/views/calendar.json';
import resolutionDocumentDashboardView from '../pages/resolution-document/views/dashboard.json';

/** Тип запису «Документ постанови» зі сторінками пакета: меню, форми та подання з pages/resolution-document/. */
export const resolutionDocumentDefinition: IRecordTypeDefinition = {
  ...resolutionDocumentEntity,
  views: assembleViewSet({
      table: resolutionDocumentTableView,
      cards: resolutionDocumentCardsView,
      calendar: resolutionDocumentCalendarView,
      dashboard: resolutionDocumentDashboardView,
  }),
  form: resolutionDocumentFullForm,
  forms: { full: resolutionDocumentFullForm, context: resolutionDocumentContextForm, mini: resolutionDocumentMiniForm, lookup: resolutionDocumentLookupForm },
  menu: resolutionDocumentMenu,
} as IRecordTypeDefinition;
